module.exports = {"data":{"markdownRemark":{"html":"<p>We love traveling and writing about it! Scribbling in our diaries after a day full of adventures is the perfect way to experience all of it TWICE :)</p>\n<p><a href=\"sydney-new-zealand-journal\">Read about our adventures in Sydney and New Zealand!</a></p>","frontmatter":{"title":"Our adventures","date":null}}},"pathContext":{"slug":"/our-adventures","prev":{"fields":{"slug":"/weird-about-us"},"frontmatter":{"title":"Weird about US"}},"next":false}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/our-adventures.json
// module id = 402
// module chunks = 236186899827500